export default __webpack_public_path__ + "static/media/landing_yellow_papper_airplane.c227986b.png";